import { render, staticRenderFns } from "./ReceiveTaskDetail.vue?vue&type=template&id=295fe2a9&"
import script from "./ReceiveTaskDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiveTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295fe2a9')) {
      api.createRecord('295fe2a9', component.options)
    } else {
      api.reload('295fe2a9', component.options)
    }
    module.hot.accept("./ReceiveTaskDetail.vue?vue&type=template&id=295fe2a9&", function () {
      api.rerender('295fe2a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/ReceiveTaskDetail.vue"
export default component.exports